import { render, staticRenderFns } from "./FormParentInfo.vue?vue&type=template&id=85716446&lang=pug&"
import script from "./FormParentInfo.vue?vue&type=script&lang=js&"
export * from "./FormParentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports